import { Component, OnInit, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    this.initializeFooterAnimations();
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.checkFooterAnimations();
  }

  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      // Get navbar height for offset
      const navbar = document.querySelector('.navbar') as HTMLElement;
      const navbarHeight = navbar ? navbar.offsetHeight : 0;
      
      // Calculate the target scroll position with offset
      const elementPosition = element.offsetTop - navbarHeight - 20;
      
      // Smooth scroll to the target position
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  }

  openEmail(email: string) {
    window.open(`mailto:${email}`, '_blank');
  }

  openPhone(phone: string) {
    window.open(`tel:${phone}`, '_blank');
  }

  private initializeFooterAnimations() {
    // Initialize intersection observer for footer animations
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('footer-animate');
        } else {
          entry.target.classList.remove('footer-animate');
        }
      });
    }, {
      threshold: 0.2,
      rootMargin: '0px 0px -100px 0px'
    });

    // Observe footer elements
    setTimeout(() => {
      const footerElements = document.querySelectorAll('.footer-column, .footer-links li, .contact-item');
      footerElements.forEach((element, index) => {
        element.setAttribute('data-delay', (index * 0.1).toString());
        observer.observe(element);
      });
    }, 100);
  }

  private checkFooterAnimations() {
    const footer = document.querySelector('.modern-footer');
    if (footer) {
      const rect = footer.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      if (rect.top < windowHeight * 0.9 && rect.bottom > windowHeight * 0.1) {
        footer.classList.add('footer-visible');
      } else {
        footer.classList.remove('footer-visible');
      }
    }
  }
}
